<template>
  <div class="tabs">
    <!-- Tabs Navigation -->
    <div class="tabs__navigation">
      <!-- Tabs navigation item -->
      <div class="tabs__navigation__item">
        <!-- Tabs navigation link -->
        <router-link :to="{name: 'profile-settings'}" class="tabs__navigation__item__link" exact>Your Profile</router-link>
      </div>

      <!-- Tabs navigation item -->
      <!-- <div class="tabs__navigation__item"> -->
        <!-- Tabs navigation link -->
        <!-- <router-link :to="{name: 'general-settings'}" class="tabs__navigation__item__link" exact>General</router-link>
      </div> -->
      <!-- Tabs navigation item -->
      <div class="tabs__navigation__item">
        <!-- Tabs navigation link -->
        <router-link :to="{name: 'team-settings'}" class="tabs__navigation__item__link" exact>Team</router-link>
      </div>
      
      <!-- Tabs navigation item -->
      <div class="tabs__navigation__item">
        <!-- Tabs navigation link -->
        <router-link :to="{name: 'API-settings'}" class="tabs__navigation__item__link" exact>API</router-link>
      </div>

      <!-- Tabs navigation item -->
      <div class="tabs__navigation__item" v-if="enableActions">
        <!-- Tabs navigation link -->
        <router-link :to="{name: 'config-settings'}" class="tabs__navigation__item__link" exact>Preferences</router-link>
      </div>
      <!-- Tabs navigation item -->
      <!-- <div class="tabs__navigation__item"> -->
        <!-- Tabs navigation link -->
        <!-- <router-link :to="{name: 'notification-settings'}" class="tabs__navigation__item__link" exact>Notifications</router-link> -->
      <!-- </div> -->

      <!-- Tabs navigation item -->
      <!-- <div class="tabs__navigation__item"> -->
        <!-- Tabs navigation link -->
        <!-- <router-link :to="{name: 'API-settings'}" class="tabs__navigation__item__link" exact>API</router-link> -->
      <!-- </div> -->
    </div>
    
    <div class="tabs__content">
      <!-- tab content item -->
      <div class="tabs__content__item active">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    enableActions: {
      get() {
        return this.$store.state.enableActions;
      },
    },
  }
};
</script>






// WEBPACK FOOTER //
// src/components/settings/SettingsBase.vue